import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { StrictMode } from 'react';
import { QueryClientProvider } from './ts-rest.js';

export function RootProvider({ children }: { children: React.ReactNode }) {
    return (
        <StrictMode>
            <FluentProvider data-fluent-provider theme={webLightTheme}>
                <QueryClientProvider>{children}</QueryClientProvider>
            </FluentProvider>
        </StrictMode>
    );
}
